import React from "react";

import BaseComponent from "../../../../baseComponent";
import InternalEvent from "../../../../../core/constants/internalEvent";
import IndividualLegend from "./individualLegend.jsx";
import CompositeLegend from "./compositeLegend.jsx";
import WidgetService from "../../../../../core/services/widgetService";
import TemplateParser from "../../../../../core/utils/templateParser";
import styles from "./styles.scss";

export default class TimeSeriesLegends extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      legends: this.props.legends
    }
  }

  componentDidMount() {
    this.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, this.updateLegend);
    this.subscribe(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, () => {
      this.updateLegend({
        widgetId: this.props.widgetId,
        updateState: false
      });
    });
    this.subscribe(InternalEvent.Dashboard.DASHBOARD_VARIABLE_UPDATED, () => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  handleLegendUpdated() {
    this.updateLegend();
    this.publish(InternalEvent.Dashboard.CHART_LEGEND_UPDATED);
  }

  updateLegend({widgetId, updateState = true}) {
    if (widgetId === this.props.widgetId) {
      const widget = WidgetService.getWidget(this.props.widgetId);
      if (widget) {
        const newLegends = widget.legends;
        this.setState({
          legends: this.deepCopy(newLegends)
        });

        if (updateState) {
          this.publish(InternalEvent.Dashboard.UPDATE_DASHBOARD_STATE);
        }
      }
    }
  }

  renderLegendController(widgetId, legends) {
    const widget = WidgetService.getWidget(widgetId);
    const legendsToRender = [];
    legends.forEach(l => {
      const toAdd = widget.legends.find(wl => wl.id === l.id);
      if(toAdd) {
        legendsToRender.push(toAdd);
      }
    });

    this.publish('openLegendConfig', {
      widgetId,
      legends: legendsToRender
    });
  }

  groupLegends(legends) {
    const legendsGroup = {};
    legends.forEach(legend => {
      const groupId = legend.parameters.groupId;
      if (legendsGroup.hasOwnProperty(groupId)) {
        legendsGroup[groupId].push(legend);
      } else {
        legendsGroup[groupId] = [legend];
      }
    });
    return legendsGroup;
  }

  render() {
    let widgetId = this.props.widgetId;
    let targetSide;
    let marginLeft = 0;
    let leftYAxisLegends = [], rightYAxisLegends = [];
    const legendsGroup = this.groupLegends(this.state.legends);
    const verticalStyle = {
      display: 'flex',
      flexDirection: 'column'
    };

    if (this.props.metaData.alignLegend) {
      marginLeft = this.props.metaData.margins.left - 10;
    }

    for (let groupId in legendsGroup) {
      if (legendsGroup[groupId].length === 2) {
        targetSide = legendsGroup[groupId][0].parameters.yAxisSide === 'left' ? leftYAxisLegends : rightYAxisLegends;
        targetSide.push(<CompositeLegend
          key={legendsGroup[groupId][0].id}
          legends={legendsGroup[groupId]}
          widgetId={widgetId}
          evalLegendLabel={TemplateParser.parseTemplate}
          renderLegendController={this.renderLegendController}
          onLegendChange={this.handleLegendUpdated}/>);
      } else {
        targetSide = legendsGroup[groupId][0].parameters.yAxisSide === 'left' ? leftYAxisLegends : rightYAxisLegends;
        // hide hidden legend
        if (legendsGroup[groupId][0].parameters.legendVisible !== false) {
          targetSide.push(<IndividualLegend
            key={legendsGroup[groupId][0].id}
            legend={legendsGroup[groupId][0]}
            widgetId={widgetId}
            evalLegendLabel={TemplateParser.parseTemplate}
            renderLegendController={this.renderLegendController}
            onLegendChange={this.handleLegendUpdated}/>);
        }
      }
    }

    // hide left or right axis
    if (this.props.metaData.yAxisVisibility === "right") {
      leftYAxisLegends = null;
    } else if (this.props.metaData.yAxisVisibility === "left") {
      rightYAxisLegends = null;
    }

    return (
      <div className={styles.legendsContainer} style={this.props.style ? this.props.style : {marginLeft}}
           name="legendContainer" ref="legendContainer">
        <div style={this.props.vertical ? verticalStyle : {}}>
          {leftYAxisLegends}
        </div>
        <div style={this.props.vertical ? verticalStyle : {}}>
          {rightYAxisLegends}
        </div>
        <div ref="legendEditContainer"/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/legend/legends.jsx